module.exports = __webpack_public_path__ + "static/media/logo.80ccd59e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/logo.svg
// module id = 62
// module chunks = 0